"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  de: {
    notFoundPage: {
      message: 'Das Element oder die Seite wurde nicht gefunden oder Sie haben keine Berechtigung zum Anzeigen.'
    },
    loginPage: {
      title: 'Anmeldung zu Sprinx CRM',
      username: 'Benutzername',
      password: 'Passwort',
      loginButton: 'Anmelden'
    },
    loginErrorPage: {
      title: 'Anmeldung fehlgeschlagen',
      error: 'Anmeldung fehlgeschlagen. Benutzername oder Passwort nicht gefunden.',
      pleaseRelogin: 'Es sieht so aus, als wären Sie nicht angemeldet. Bitte melden Sie sich erneut an.'
    },
    oauthLogin: {
      message: 'Sie müssen sich anmelden. Bitte wählen Sie einen der aufgeführten Anbieter aus.',
      loginButton: 'Melden Sie sich mit einem Sprinx-Konto an',
      redirecting: 'Warte auf Weiterleitung zum Authentifizierungsserver ...'
    },
    logout: {
      inProgress: 'Ausloggen...',
      error: 'Abmeldefehler',
      gotoHome: 'Weiterleiten zur Startseite',
      success: 'Abmeldung war erfolgreich.'
    }
  }
};
var _default = messages;
exports.default = _default;